module.exports = __webpack_public_path__ + "static/resources-e6e361d16db93f5d39b7941bbf7b06b5.png";